import { handleActions } from 'redux-actions';
import {
  setSelectedTierId,
  setSelectedTierContentType,
} from '../actions/subscriptionsSection';
import {
  default as SubscriptionsSection,
  SubscriptionsTierContentType,
} from '../../types/subscriptionsSection';

const defaultState: SubscriptionsSection = {
  selectedTierId: undefined,
  tierContentType: SubscriptionsTierContentType.DEVIATIONS,
};

export default handleActions<SubscriptionsSection, any>(
  {
    [setSelectedTierContentType.toString()]: (
      state: SubscriptionsSection,
      action: ReturnType<typeof setSelectedTierContentType>
    ) => ({
      ...state,
      tierContentType: action.payload,
    }),
    [setSelectedTierId.toString()]: (
      state: SubscriptionsSection,
      action: ReturnType<typeof setSelectedTierId>
    ) => ({
      ...state,
      selectedTierId: action.payload,
    }),
  },
  defaultState
);
